export default __webpack_public_path__ + "static/media/verify-email-check.0acebf79.svg";